<template>
  <div>
    QUESTIONS
    <div
      v-if="fetchInProgress"
      class="h-24 w-48 flex justify-center items-center"
    >
      <Spinner class="text-yellow-400" />
    </div>
    <template v-else>
      <el-checkbox-group
        v-model="selectedQuestions"
        class="my-4 space-y-4 pr-8"
      >
        <div
          v-for="question in program.questions"
          :key="question.id"
          class="flex flex-col"
        >
          <div class="flex items-center space-x-2 w-full group">
            <div class="flex items-center justify-center p-2">
              <el-checkbox :label="question.id">&nbsp;</el-checkbox>
            </div>
            <p
              class="text-base my-0 cursor-pointer group-hover:opacity-100"
              :class="{
                'opacity-70': !isSelected(question.id),
              }"
              @click="toggle(question.id)"
            >
              {{ question.text }}
            </p>
          </div>
        </div>
      </el-checkbox-group>
      <div>
        <Button type="primary" @click="save()" :loading="saveInProgress">
          Save
        </Button>
        <Button @click="close()">Cancel</Button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Spinner from 'components/common/Spinner.vue'
import Button from 'components/common/Button.vue'
import TextButton from 'components/common/TextButton.vue'
import Checkbox from 'components/forms/Checkbox.vue'

export default {
  components: {
    Button,
    TextButton,
    Spinner,
    Checkbox,
  },
  computed: {
    ...mapState({
      program: (state) => state.organizationProgramDetails.program,
      fetchInProgress: (state) =>
        state.organizationProgramDetails.fetchInProgress,
      saveInProgress: (state) => state.eventDetails.saveInProgress,
      showroom: (state) => state.eventDetails.event,
    }),
  },
  data() {
    return {
      selectedQuestions: [],
    }
  },
  watch: {
    program(p) {
      const config = this.showroom.program_config
      if (!config.questions) {
        this.selectedQuestions = p.questions.map((q) => q.id)
      }
    },
  },
  created() {
    const config = this.showroom.program_config
    if (config.questions) {
      this.selectedQuestions = config.questions
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    async save() {
      await this.$store.dispatch('eventDetails/update', {
        program_config: {
          questions: this.selectedQuestions,
        },
      })
      this.$notify({
        type: 'success',
        title: 'Saved',
        message: 'Config updated',
      })
      this.close()
    },
    isSelected(questionId) {
      return this.selectedQuestions.includes(questionId)
    },
    toggle(questionId) {
      if (this.isSelected(questionId)) {
        this.selectedQuestions = this.selectedQuestions.filter(
          (qId) => qId !== questionId,
        )
      } else {
        this.selectedQuestions = [...this.selectedQuestions, questionId]
      }
    },
  },
}
</script>

<style scoped>
.el-checkbox {
  margin-bottom: 0;
}
</style>
